import { useEffect, useState } from "react";
import { Send } from "lucide-react";
import Logo from "@/components/Logo";
import { TELEGRAM_URL } from "@/config";
import { scrollToId } from "@/lib/ui";

const LINKS = [
    { id: "come-funziona", label: "Come funziona" },
    { id: "offerte", label: "Offerte" },
    { id: "perche-noi", label: "Perché noi" },
    { id: "faq", label: "FAQ" },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="navbar"
            className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "glass border-b border-ink/5 shadow-[0_8px_30px_-12px_rgba(11,18,32,0.15)]"
                    : "bg-transparent"
            }`}
        >
            <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 md:h-[72px] lg:px-8">
                <a
                    href="/"
                    data-testid="navbar-home-link"
                    className="transition-transform duration-300 hover:scale-[1.02]"
                >
                    <Logo />
                </a>

                <nav className="hidden items-center gap-8 md:flex">
                    {LINKS.map((l) => (
                        <button
                            key={l.id}
                            onClick={() => scrollToId(l.id)}
                            data-testid={`nav-link-${l.id}`}
                            className="nav-link text-sm font-medium text-ink/60 transition-colors duration-300 hover:text-ink"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>

                <a
                    href={TELEGRAM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="nav-telegram-cta"
                    className="group inline-flex items-center gap-2 rounded-full bg-ink px-4 py-2.5 text-[13px] font-bold text-white transition-all duration-300 hover:bg-telegram hover:shadow-[0_10px_25px_-8px_rgba(34,158,217,0.6)] sm:px-5"
                >
                    <Send className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                    <span className="hidden sm:inline">Entra su Telegram</span>
                    <span className="sm:hidden">Telegram</span>
                </a>
            </div>
        </header>
    );
}
